import { usersWorkHoursPercentage } from '../../../utils/usersWorkHoursPercentage'

export const getApplicantsInput = (
  cities,
  activities,
  banks,
  works,
  projects,
  departments,
  managers,
  projectManagers,
  teamLeaders,
  functions,
  languages,
  applicantStatus
) => {
  return [
    {
      text: 'Emri',
      value: 'firstName'
    },
    {
      text: 'Mbiemri',
      value: 'lastName'
    },
    applicantStatus === 'waiting_list' || applicantStatus === 'failed'
      ? {
          text: 'Fjalekalimi',
          value: 'password',
          type: 'password'
        }
      : null,
    {
      text: 'Alias',
      value: 'alias'
    },
    // {
    //   text: 'Team',
    //   value: 'team'
    // },
    {
      text: 'Email Adresa',
      value: 'email'
    },
    {
      text: 'Email Personal',
      value: 'personal_email'
    },
    {
      text: 'Numri i leternjoftimit',
      value: 'idNumber'
    },
    {
      text: 'Statusi martesor',
      value: 'marital_status',
      select: [
        { key: '1', value: 'Beqar/e', text: 'Beqar/e' },
        {
          key: '2',
          value: 'I/e martuar',
          text: 'I/e martuar'
        },
        {
          key: '3',
          value: 'I/e divorcuar',
          text: 'I/e divorcuar'
        },
        { key: '4', value: 'I/e ve', text: 'I/e ve' }
      ]
    },
    {
      text: 'Telefoni',
      value: 'contactNumber',
      placeholder: '3834xxxxxxx'
    },
    {
      text: 'Kontakti emergjent',
      value: 'emergencyContactNumber'
    },
    {
      text: 'Adresa',
      value: 'birthplace'
    },
    {
      text: 'Qyteti',
      value: 'city',
      select: cities
    },
    {
      text: 'Aktiviteti',
      value: 'activity',
      select: activities
    },
    {
      text: 'Banka',
      value: 'bank',
      select: banks
    },
    {
      text: 'Llogaria Bankare',
      value: 'bank_account_no'
    },
    {
      text: 'Rroga baze',
      value: 'base_salary',
      type: 'number'
    },
    {
      text: 'Skill Bonus',
      value: 'skill_bonus',
      type: 'number'
    },
    {
      text: 'Koha e punes se punetorit',
      value: 'work_percentage',
      select: usersWorkHoursPercentage.map((item, i) => ({ key: i + 1, value: item.percentage, text: item.value }))
    },
    {
      text: 'Punëdhënësi',
      value: 'employeer',
      select: [
        { key: '1', value: 'Primar', text: 'Primar' },
        { key: '2', value: 'Sekondar', text: 'Sekondar' }
      ]
    },
    {
      text: 'Komente për rekrutim',
      value: 'comment_box',
      type: 'textarea'
    },
    {
      text: 'SPEEEX Badge',
      value: 'speeex_badge'
    },
    {
      text: 'Lokacioni i punës',
      value: 'office_location',
      select: [
        { key: '1', value: 'Prishtinë HQ', text: 'Prishtinë HQ' },
        { key: '2', value: 'Ferizaj', text: 'Ferizaj' },
        { key: '3', value: 'Vushtrri', text: 'Vushtrri' },
        { key: '4', value: 'Prizren', text: 'Prizren' },
        { key: '5', value: 'HO-Prishtinë', text: 'HO-Prishtinë' },
        { key: '6', value: 'HO-Ferizaj', text: 'HO-Ferizaj' },
        { key: '7', value: 'HO-Vushtrri', text: 'HO-Vushtrri' },
        { key: '8', value: 'HO-Prizren', text: 'HO-Prizren' }
      ]
    },
    {
      text: 'Statusi i punës',
      value: 'work',
      select: works
    },
    {
      text: 'Lejeqëndrim',
      value: 'residence_permit',
      checkbox: 'residence_permit'
    },
    {
      text: 'Llogaria e Trustit',
      value: 'trust_account',
      checkbox: 'trust_account'
    },
    {
      text: 'Llogaritet Trusti në pagë',
      value: 'should_include_trust',
      checkbox: 'should_include_trust'
    },
    {
      text: 'Certifikata nen hetime',
      value: 'court_certificate',
      checkbox: 'court_certificate'
    },
    {
      text: 'Certifikata shendetesore',
      value: 'health_certificate',
      checkbox: 'health_certificate'
    },
    {
      text: 'SSHP',
      value: 'health_safety_certificate',
      checkbox: 'health_safety_certificate'
    },
    {
      text: 'Firecase Certificate',
      value: 'fire_case_certificate',
      checkbox: 'fire_case_certificate'
    },
    {
      text: 'Data e lindjes',
      value: 'birthdate',
      datepicker: 'birthdate'
    },
    {
      text: 'Dita e parë',
      value: 'first_call',
      datepicker: 'first_call'
    },
    {
      text: 'Gjinia',
      value: 'gender',
      select: [
        { key: '1', value: 'Mashkull', text: 'Mashkull' },
        { key: '2', value: 'Femer', text: 'Femer' }
      ]
    },
    {
      text: 'Nacionaliteti',
      value: 'nationality'
    },
    {
      text: 'Shtetësia',
      value: 'citizenship'
    },
    {
      text: 'Niveli i Perdoruesit',
      value: 'user_level',
      select: [
        { key: '1', value: '1', text: 'Administrator' },
        { key: '2', value: '2', text: 'Manager' },
        { key: '3', value: '3', text: 'Team Leader' },
        { key: '4', value: '4', text: 'Perdorues i thjeshte' },
        { key: '5', value: '5', text: 'HR Manager' },
        { key: '6', value: '6', text: 'HR Admin' },
        { key: '7', value: '7', text: 'Mirembajtes' },
        { key: '8', value: '8', text: 'Koordinator i pushimeve' },
        { key: '9', value: '1', text: 'Payroll' }
      ]
    },
    {
      text: 'Projekti',
      value: 'project',
      select: projects
    },
    {
      text: 'Departamenti',
      value: 'department',
      select: departments
    },
    {
      text: 'Manager',
      value: 'manager',
      select: managers
    },
    {
      text: 'Project Manager',
      value: 'has_project_manager',
      select: projectManagers
    },
    {
      text: 'Team Leader',
      value: 'teamleader',
      select: teamLeaders
    },
    {
      text: 'Funksioni',
      value: 'function',
      select: functions
    },
    {
      text: 'Gjuhet',
      value: 'languages',
      select: languages
    }
  ]
}

export const requiredApplicantFields = [
  {
    text: 'Email Adresa',
    value: 'email'
  },
  {
    text: 'Fjalekalimi',
    value: 'password'
  },
  {
    text: 'Numri i leternjoftimit',
    value: 'idNumber'
  },
  {
    text: 'Emri',
    value: 'firstName'
  },
  {
    text: 'Mbiemri',
    value: 'lastName'
  },
  {
    text: 'Niveli i Perdoruesit',
    value: 'user_level'
  },
  {
    text: 'Manager',
    value: 'manager'
  },
  {
    text: 'Statusi martesor',
    value: 'marital_status'
  },
  {
    text: 'Funksioni',
    value: 'function'
  },
  {
    text: 'Aktiviteti',
    value: 'activity'
  },
  {
    text: 'Koha e punes se punetorit',
    value: 'work_percentage'
  },
  {
    text: 'Punëdhënësi',
    value: 'employeer'
  },
  {
    text: 'Lokacioni i punës',
    value: 'office_location'
  },
  {
    text: 'Data e lindjes',
    value: 'birthdate'
  },
  {
    text: 'Dita e parë',
    value: 'first_call'
  },
  {
    text: 'Departamenti',
    value: 'department'
  },
  {
    text: 'Certifikata nen hetime',
    value: 'court_certificate'
  },
  {
    text: 'Certifikata shendetesore',
    value: 'health_certificate'
  },
  {
    text: 'Llogaria Bankare',
    value: 'bank_account_no'
  },
  {
    text: 'Banka',
    value: 'bank'
  },
  {
    text: 'Statusi i punës',
    value: 'work'
  },
  {
    text: 'Projekti',
    value: 'project'
  },
  {
    text: 'Gjuhet',
    value: 'languages'
  },
  { text: 'Numri Kontaktit', value: 'contactNumber' },
  { text: 'Adresa', value: 'birthplace' }
]

export const buttonsApplicants = [
  {
    type: 'low',
    text: 'Mark as weak',
    showOnStatus: ['new', 'interview']
  },
  {
    type: 'spxedu',
    text: 'Add to Speeex Education',
    showOnStatus: ['low', 'failed']
  },
  {
    type: 'testing',
    text: 'Add to testing',
    showOnStatus: ['will_be_tested']
  },
  {
    type: 'will_be_tested',
    text: 'Will be tested',
    showOnStatus: ['new', 'interview']
  },
  {
    type: 'waiting_list',
    text: 'Passed',
    showOnStatus: ['testing']
  },
  {
    type: 'recruited',
    text: 'Recrute',
    showOnStatus: ['waiting_list', 'failed']
  },
  {
    type: 'failed',
    text: 'Failed',
    showOnStatus: ['testing']
  },
  {
    type: 'declined',
    text: 'Refuse',
    showOnStatus: ['new', 'interview', 'low', 'spxedu', 'testing', 'will_be_tested', 'waiting_list', 'recruited', 'failed']
  },
  {
    type: 'blacklist',
    text: 'Add to Balcklist',
    showOnStatus: ['new', 'interview', 'low', 'spxedu', 'testing', 'will_be_tested', 'waiting_list', 'recruited', 'declined', 'failed']
  }
]
